import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pgbaForms: {
    covid19: {
      id: 'forms.covid',
      defaultMessage: 'Covid-19',
    },
    electionaddendum: {
      id: 'forms.electionaddendum',
      defaultMessage: 'Election Addendum',
    },
  },
  nonPgbaForms: {
    covid19: {
      id: 'forms.covid',
      defaultMessage: 'Covid-19',
    },
    electionaddendum: {
      id: 'forms.electionaddendum',
      defaultMessage: 'Election Addendum',
    },
  },
  forms: {
    nursing: {
      id: 'forms.nursing',
      defaultMessage: 'Nursing',
    },
    socialServices: {
      id: 'forms.social-services',
      defaultMessage: 'Social Services',
    },
    spiritual: {
      id: 'forms.spiritual',
      defaultMessage: 'Spiritual',
    },
    physician: {
      id: 'forms.physician',
      defaultMessage: 'Physician',
    },
    volunteer: {
      id: 'forms.volunteer',
      defaultMessage: 'Volunteer',
    },
    fallRisk: {
      id: 'forms.fall-risk',
      defaultMessage: 'Fall Risk',
    },
  },
  chooseQuestionnaire: {
    id: 'forms-common.choose-questionnaire',
    defaultMessage: 'Choose Questionnaire',
  },
});
